import React from "react";

const ShareholderPercentageWarningIcon = ({ change, className = "" }) => {
  if (!change) return null;

  const getTooltipText = () => {
    const parts = [];

    // Shareholding
    if (
      typeof change.shareholdingChange !== "undefined" &&
      Math.abs(change.shareholdingChange) > 0.001
    ) {
      const direction =
        change.shareholdingChange > 0 ? "Increased" : "Decreased";
      const changeText =
        change.shareholdingChange > 0
          ? `+${change.shareholdingChange.toFixed(2)}%`
          : `${change.shareholdingChange.toFixed(2)}%`;
      parts.push(
        `Shareholding ${direction}: ${change.originalPercentage.toFixed(
          2
        )}% → ${change.newPercentage.toFixed(2)}% (${changeText})`
      );
    }

    // Voting Rights
    if (
      typeof change.votingRightsChange !== "undefined" &&
      Math.abs(change.votingRightsChange) > 0.001
    ) {
      const direction =
        change.votingRightsChange > 0 ? "Increased" : "Decreased";
      const changeText =
        change.votingRightsChange > 0
          ? `+${change.votingRightsChange.toFixed(2)}%`
          : `${change.votingRightsChange.toFixed(2)}%`;
      parts.push(
        `Voting Rights ${direction}: ${change.originalVotingPercentage.toFixed(
          2
        )}% → ${change.newVotingPercentage.toFixed(2)}% (${changeText})`
      );
    }

    if (parts.length === 0) {
      // Fallback for legacy format or just in case
      const direction = change.hasIncreased ? "Increased" : "Decreased";
      const changeText =
        change.change > 0
          ? `+${change.change.toFixed(2)}%`
          : `${change.change.toFixed(2)}%`;
      return `Shareholding ${direction}: ${change.originalPercentage.toFixed(
        2
      )}% → ${change.newPercentage.toFixed(2)}% (${changeText})`;
    }

    return parts.join("\n");
  };

  return (
    <div
      className={`relative inline-flex group ${className}`}
      title={getTooltipText()}
    >
      <div className="bg-orange-100 rounded-full p-1 border border-orange-300">
        <svg
          className="w-5 h-5 text-orange-600 animate-pulse cursor-help"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
};

export default ShareholderPercentageWarningIcon;
